<template >
  <!-- .catalog-tree
  .parent-wrap
    .name 
      i.el-icon-folder-add(
        v-show="!currentData.fold",
        @click="handleFold(true)"
      )
      i.el-icon-folder-remove(
        v-show="currentData.fold",
        @click="handleFold(false)"
      )
      span {{ currentData.courseName }}
    tree(
      :currentId="currentId",
      :choose="choose",
      v-show="currentData.fold",
      v-if="currentData.chapters && currentData.chapters.length",
      :dataSource="currentData.chapters"
    ) -->

  <div class="catalog-tree">
    <div class="parent-wrap">
      <div class="name">
        <i
          class="el-icon-folder-add"
          v-show="!currentData.fold"
          @click="handleFold(true)"
        ></i>
        <i
          class="el-icon-folder-remove"
          v-show="currentData.fold"
          @click="handleFold(false)"
        ></i>
        <span> {{ currentData.courseName }}</span>
      </div>
      <tree
        :currentId="currentId"
        :choose="choose"
        v-show="currentData.fold"
        v-if="currentData.chapters && currentData.chapters.length"
        :dataSource="currentData.chapters"
      ></tree>
    </div>
  </div>
</template>

<script>
import tree from "./CatalogTree";
import _ from "lodash";
export default {
  data() {
    return {
      currentData: {},
      currentId: 0
    };
  },
  watch: {
    dataSource: {
      handler(val) {
        this.currentData = _.cloneDeep(val);
        this.$set(this.currentData, "fold", true);
        if (this.currentData.chapters.length > 0) {
          for (var i = 0; i < this.currentData.chapters.length; i++) {
            this.recursion(this.currentData.chapters[i]);
          }
        }
        if (val.addId) {
          this.$nextTick(() => {
            this.choose({ id: val.addId });
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.dataSource && (this.currentData = _.cloneDeep(this.dataSource));
    this.$set(this.currentData, "fold", true);
  },
  props: ["dataSource"],
  methods: {
    recursion(data) {
      if (data.type == 1) {
        this.$set(data, "fold", true);
        if (data.subChapters.length > 0) {
          for (var i = 0; i < data.subChapters.length; i++) {
            this.recursion(data.subChapters[i]);
          }
        } else {
          return;
        }
      }
      return;
    },
    handleFold(flag) {
      this.currentData.fold = flag;
    },
    choose(val) {
      this.currentId = val.id;
      this.$emit("on-choose", val);
    },
    handleDragStart(node, ev) {
      console.log("drag start", node);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      console.log("tree drag enter: ", dropNode.label);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      console.log("tree drag leave: ", dropNode.label);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      console.log("tree drag over: ", dropNode.label);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      console.log("tree drag end: ", dropNode && dropNode.label, dropType);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log("tree drop: ", dropNode.label, dropType);
    },

    allowDrag(draggingNode, dropNode, type) {
      console.log(draggingNode, "draggingNode");
      return draggingNode.data.label.indexOf("三级 3-2-2") === -1;
    },

    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.level === dropNode.level) {
        if (draggingNode.parent.id === dropNode.parent.id) {
          // 向上拖拽 || 向下拖拽
          return type === "prev" || type === "next";
        }
      } else {
        // 不同级进行处理
        return false;
      }
    }
  },
  components: {
    tree
  }
};
</script>

<style lang="less" scoped>
.catalog-tree {
  font-size: 16px;
  font-weight: 400;
  .name {
    margin-bottom: 4px;
    i {
      margin-right: 6px;
    }
    i.el-icon-folder-add,
    i.el-icon-folder-remove {
      cursor: pointer;
    }
  }
}
</style>